import { Component } from 'react';
import OverviewRadarVideoComponent from '../overview/OverviewRadarVideoComponent';

class FooterComponent extends Component {
  render() {
    return (
      <div>
        <footer>
          <div className="sponsorLogos">
            <strong>Deze website wordt u aangeboden door:</strong>

            <a href="https://fastlane.hypotheekbond.nl/" target="_blank" rel="noreferrer">
              <img src="/images/FL_logo.svg" alt="Fastlane" />
            </a>
            <a href="https://zakelijk.hypotheekbond.nl/" target="_blank" rel="noreferrer">
              <img src="/images/NHB_logo.svg" alt="de Nationale Hypotheekbond" />
            </a>
            <a href="https://www.actiefbeheerscan.nl/" target="_blank" rel="noreferrer">
              <img src="/images/ABS_logo.svg" alt="Actiefbeheerscan" className="ABS_logo"/>
            </a>
          </div>

          <div className="content">
            <p>Met deze website willen wij de transparantie in de financiële dienstverlening bevorderen.</p>
            <p>
              Wij vermelden deze tarieven op onze site om u zo goed
              mogelijk te informeren. Hierbij gaan wij zorgvuldig te werk.
              Aan deze informatie kunt u geen rechten ontlenen. U kunt ons
              niet aansprakelijk stellen als deze informatie, bijvoorbeeld
              door een typefout, onjuist is. Onze tarieven kunnen dagelijks
              worden gewijzigd.
            </p>
            <a
              href="https://www.hfbg.nl/privacy"
              className="bold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </a>
            <br/>
            <a
              href="https://plus.google.com/communities/106238153627541051920"
              className="bold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Looptijdrente in de pers
            </a>
          </div>
        </footer>
        <OverviewRadarVideoComponent/>
      </div>
    );
  }
}

export default FooterComponent;
